//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import probanner from '@/components/newprobanner'
import hotlist from '@/components/hotlist'
import commonlist from '@/components/commonlist'
import tablelist from '@/components/tablelist'
import ullist from '@/components/ullist'
import {
	queryHtyxList,
	queryCustomFund,
	queryFollowFund,
	queryRankingList,
	queryRankingDetail,
	searchProListByType,
	queryLcSearchList,
	getAppggList
} from '@/service/service'
import {
	mapState,
	mapMutations
} from 'vuex'
import config from '../../config/config'
import {
	setTimeout
} from 'timers';

export default {
	data() {
		return {
			htyxData: [],
			bkjjData: [],
			jxlcData: [],
			CustomFundData: [],
			FollowFund: [],
			RankingList: [],
			RankingListOne: [],
			RankingTypeOne: [],
			RankingDetailOne: [],
			RankingListTwo: [],
			RankingTypeTwo: [],
			RankingDetailTwo: [],
			rankType: '1',
			currOne: '',
			currTwo: '',
			searchText: '',
			searchArr: [],
			isEmpty: true,
			searchActive: false,
			swiperOption: {
				slidesPerView: 'auto',
				mousewheel: true,
				observer: true,
				observeParents: true
			},
			searchType: '1',
			searchInput: '',
			rank_title: "",
			lc_search_index: '0',
			lc_search_list_qx_arr: [{
				text: '全部',
				type: '0'
			}, {
				text: '0-3个月',
				type: '90'
			}, {
				text: '3-12个月',
				type: '90%2c365'
			}, {
				text: '12个月以上',
				type: '365'
			}, {
				text: '灵活不定期',
				type: 'flexible'
			}],
			lc_search_data: [],
			isNewsInit: false,
			newsList: [],
			showIframe: false,
			tempItem: [],
			isFullIframe: false,
			fundList: [],
			currType: 'all',
			fundType: [{
				type: 'all',
				text: '全部'
			},
			{
				type: '0',
				text: '自选'
			},
			{
				type: '1',
				text: '股票型'
			},
			{
				type: '2',
				text: '混合型'
			},
			{
				type: '3',
				text: '债券型'
			},
			{
				type: '6',
				text: '货币型'
			},
			{
				type: '5',
				text: '保本型'
			},
			{
				type: '7',
				text: '分级基金'
			},
			{
				type: 'zs',
				text: '指数型'
			},
			{
				type: 'lc',
				text: '理财型'
			},
			{
				type: '21',
				text: 'QDII'
			}],
			isFundInit: false, //请求基金数据成功
			isTrendInit: false, //请求榜单数据成功
			isFinanInit: false, //请求理财数据成功
		}
	},
	components: {
		probanner,
		hotlist,
		commonlist,
		tablelist,
		ullist
	},
	computed: {
		...mapState(['follow']),
		config: () => {
			return config
		}
	},
	methods: {
		...mapMutations({
			updata_follow: 'UPDATA_FOLLOW'
		}),
		getHtyx(type) {
			let data = {
				type: type,
				rows: ''
			}
			queryHtyxList(data).then(resultVo => {
				if (type == '1') {
					this.htyxData = resultVo.results
				} else if (type == '2') {
					this.bkjjData = resultVo.results
				} else if (type == '3') {
					this.jxlcData = resultVo.results
				}
				this.$refs.swipernew.isSwiperInit = true
			})
		},
		getCustomFund(type) {
			let data = {
				type: type == 'all' ? '' : type,
				rows: 10,
				pageId: 'fundlist',
				sort: type == '6' || type == 'lc' ? 'yield' : 'gain',
				currentPage: 1,
				filterfx: '5',
				isCanBuy: true
			}
			queryCustomFund(data).then(resultVo => {
				this.fundList = resultVo.DataSet0;
				this.isFundInit = true;
			})
		},
		getFollowList() {
			// let data = {
			// fundcode: this.$store.state.follow.split('|')[0].join('%2C')
			// }
			let fundcode = ''
			for (let i = 0; i < this.$store.state.follow.length; i++) {
				fundcode += this.$store.state.follow[i].split('|')[0] + '%2C'
			}
			let data = {
				fundcode: fundcode,
				filterfx: '5'
			}
			queryFollowFund(data).then(resultVo => {
				// this.FollowFund = res.results
				let focusResults = resultVo.results
				let focusList = []
				for (let i = 0; i < this.$store.state.follow.length; i++) {
					let fundcode = this.$store.state.follow[i].split('|')[0]
					let fundalias = this.$store.state.follow[i].split('|')[1]

					let sub_data = {}
					sub_data.key = i
					sub_data.fund_code = fundcode
					sub_data.fund_alias = fundalias

					let sub_fund_code = '--'
					// let sub_fund_alias = '--'
					let sub_daten = '--'
					let sub_navgrowthcalctype = '--'
					let sub_yield = '--'
					let sub_nav = '--'
					let sub_gain = '--'
					// sub_data.fund_alias = sub_fund_alias
					sub_data.daten = sub_daten
					sub_data.navgrowthcalctype = sub_navgrowthcalctype
					sub_data.yield = sub_yield
					sub_data.nav = sub_nav
					sub_data.gain = sub_gain
					for (let j = 0; j < focusResults.length; j++) {
						sub_fund_code = focusResults[j].fund_code
						if (fundcode && fundcode == sub_fund_code) {
							sub_data.daten = focusResults[j].daten
							sub_data.navgrowthcalctype = focusResults[j].navgrowthcalctype
							sub_data.yield = focusResults[j].yield
							sub_data.nav = focusResults[j].nav
							sub_data.gain = focusResults[j].gain
							// sub_data.push(focusResults[j]);
						}
					}
					focusList.push(sub_data)
				}
				// console.log(focusList);
				this.FollowFund = focusList
			})
		},
		getRankingList() {
			let data = {
				type: this.rankType,
				rows: '2'
			}
			queryRankingList(data).then(resultVo => {
				this.RankingList = resultVo.results
				this.rank_title = this.RankingList[1].rank_title
				queryRankingDetail({
					id: this.RankingList[0].id
				}).then(resone => {
					this.RankingListOne = resone.DataSet0[0]
					if (resone.DataSet0[0].fundtypelist == '') {
						this.RankingTypeOne = []
						for (var key in resone.DataSet1[0]) {
							this.currOne = key
						}
					} else {
						this.RankingTypeOne = JSON.parse(resone.DataSet0[0].fundtypelist)
						this.currOne = this.RankingTypeOne[0].item_value
					}
					this.RankingDetailOne = resone.DataSet1[0]
					this.isTrendInit = true;
				})
				queryRankingDetail({
					id: this.RankingList[1].id
				}).then(restwo => {
					this.RankingListTwo = restwo.DataSet0[0]
					if (restwo.DataSet0[0].fundtypelist == '') {
						this.RankingTypeTwo = []
						for (var key in restwo.DataSet1[0]) {
							this.currTwo = key
						}
					} else {
						this.RankingTypeTwo = JSON.parse(restwo.DataSet0[0].fundtypelist)
						this.currTwo = this.RankingTypeTwo[0].item_value
					}
					this.RankingDetailTwo = restwo.DataSet1[0]
					this.isTrendInit = true;
				})
			})
		},
		//获取稳健理财(1013744)
		queryLcSearchList(param) {
			queryLcSearchList({
				// pageCode: "dqlc_hasflexible",
				pageCode: "dqlc_hasflexible",
				isNavType: "",
				currentPage: param.currentPage,
				qx: param.lc_search_list_qx,
				rows: 10
			}).then(resultVo => {
				let results = resultVo.DataSet0;
				if (results && results.length > 0) {
					for (let i = 0; i < results.length; i++) {
						// 1、数据处理
						let item = results[i];
						var cpmc = item.cpmc; //产品名称
						var cpid = item.cpid; //产品ID
						var cpzt = item.cpzt; //产品状态
						var cpdm = item.cpdm; //产品代码
						var syl = item.syl; //收益率
						var cpjd = item.cpjd; //产品阶段
						var cpjz = item.cpjz; //产品净值
						var cpfl = item.cpfl; //产品分类
						var sylsx = item["sylsx"]; //收益率上限
						var sylxx = item["sylxx"]; //收益率下限
						var fxdj = item["fxdj"]; //风险等级
						var fxdj_ms = item["fxdj_ms"]; //风险等级描述
						var rgqd = item["rgqd"]; //认购起点
						var grscsgzdje = item.grscsgzdje; //个人首次申购最低金额
						var cpqxUnit = item.cpqxUnit; //产品期限单位
						var cpqxVale = item.cpqxnum; //产品期限值
						var cpqx = item.cpqx; //产品期限
						var jsllbz = item.jsllbz; //结算利率标志
						var buytips = item.buytips; //购买标识
						var jzrq = item.jzrq; //净值日期
						var es_tycpfl = item.es_tycpfl; //通用产品分类
						var es_tycpfl_zg = item.es_tycpfl_zg; //通用产品分类资管子分类
						var es_cpflbm = item.es_cpflbm; //产品分类别名
						var syl_space = item.syl_space; //20180912收益率区间中间的间隔;牛熊宝、黄金宝使用"或"间隔，指数宝使用"~"间隔
						var otczg_syl_ms = item.otczg_syl_ms; //otc和资管收益率字段描述
						var sylsx_hidesymbols = item.sylsx_hidesymbols;//(20190805指数宝增加无最高收益率的类型,最高收益率展示为∞)隐藏最高收益率符号%  1隐藏  其他不隐藏

						let _show_field_value;

						if (syl_space && sylsx) {
							//20180828-指数宝展示也展示收益率上下限 //20190214-根据区分标识pdbdsyl展示间隔syl_space
							syl = `${sylxx}%<small>${syl_space}</small>${sylsx}`;
							syl += ('1' == sylsx_hidesymbols ? '' : '%');

							var show_field_value_class =
								sylxx.length + sylsx.length > 4 ? "min" : "";
						} else {
							if (es_tycpfl_zg && es_tycpfl_zg == this.constants.ES_TYCPFL_ZG.LC) {
								syl = syl ? this.fixNum(syl, 3) + "%" : "--%";
							}
							else {
								syl = syl ? syl + "%" : "--%";
							}
							var show_field_value_class = "";
						}

						var fxdj_text = this.constants.OPENFUND_FXDJ[fxdj]

						let isneedlogin = false
						if (es_tycpfl && es_tycpfl == this.constants.ES_TYCPFL.ZG) {
							isneedlogin = false
						} else {
							isneedlogin = true
						}

						Object.assign(item, {
							show_field_value_html: syl,
							show_field_value_class,
							isneedlogin,
							fxdj_text
						});
					}

					this.lc_search_data = results
					this.isFinanInit = true
					this.$forceUpdate()
				}else{
					this.lc_search_data = []
					this.$forceUpdate()
				}
			});
		},
		getAppggList() {
			getAppggList({
				"TypeCode": "18",
				"numPerPage": 15,
				"curpage": 1
			}).then(resultVo => {
				let results = resultVo;
				if (results.error_no == '0') {
					var datalist = results["DataSet0"];// 加载列表数据
					var dataSet1 = results["DataSet1"];
					if (dataSet1 != null && dataSet1.length > 0) {
						this.newsList = datalist
						this.isNewsInit = true
					}
				}

			})
		},
		fixNum(num, pre) {
			var result = 0;
			var money = parseFloat(num).toFixed(3);
			try {
				var int_part = num.split(".")[0],
					point_num = num.split(".")[1],
					precision_num = point_num[3 - precision];
				if (precision_num > 4) {
					if (precision == 1) {
						point_num = parseInt(point_num) + 10 + "";
						if (point_num.length > 3) {
							int_part = parseInt(int_part) + 1 + "";
							point_num = point_num[1] + point_num[2];
						} else {
							point_num = point_num[0] + point_num[1];
						}
						result = parseFloat(int_part + "." + point_num);
					} else if (precision == 2) {
						point_num = parseInt(point_num) + 100 + "";
						if (point_num.length > 3) {
							int_part = parseInt(int_part) + 1 + "";
							point_num = point_num[1];
						} else {
							point_num = point_num[0];
						}
						result = parseFloat(int_part + "." + point_num);
					} else if (precision == 3) {
						int_part = parseInt(int_part) + 1 + "";
						point_num = 0;
					}
					result = parseFloat(int_part + "." + point_num);
				} else {
					if (precision == 1) {
						point_num = point_num[0] + point_num[1];
					} else if (precision == 2) {
						point_num = point_num[0];
					} else if (precision == 3) {
						point_num = 0;
					}
					result = parseFloat(int_part + "." + point_num);
				}
			} catch (e) {
				return parseFloat(num).toFixed(2);
			}
			return result;
		},
		switchOne(value) {
			this.currOne = value
			console.log(value)
		},
		switchTwo(value) {
			this.currTwo = value
			console.log(value)
		},
		switchFundType(type) {
			this.currType = type;
			if(type == 0) {

			} else {
				this.getCustomFund(type)
			}

		},
		switchDate(value) {
			this.lc_search_index = value;
			let lc_search_list_qx_arr = this.lc_search_list_qx_arr;
			this.queryLcSearchList({
				currentPage: 1,
				lc_search_list_qx: lc_search_list_qx_arr[value].type
			});
		},
		refreshRank() {
			this.rankType = '2'
			this.getRankingList()
			this.$refs.navswiper.swiper.slideTo(0, false);
		},
		inputFocus() {
			this.searchActive = true;
			this.isEmpty = true
		},
		inputBlur() {
			var _this = this;
			setTimeout(function () {
				_this.searchActive = false;
				_this.searchArr = []
			}, 500)

		},
		formatSearchData(data) {
			var arr = []
			for (var key in this.constants.product_type) {
				arr.push({
					id: key,
					text: this.constants.product_type[key],
					data: []
				})
			}
			for (var i = 0; i < data.length; i++) {
				for (var j = 0; j < arr.length; j++) {
					if (data[i].product_type == arr[j].id) {
						arr[j].data.push(data[i])
					}
				}
			}

			function sortnum(a, b) {
				return a['id'].substr(0, 1) - b['id'].substr(0, 1)
			}
			return arr.sort(sortnum)
		},
		highlight(value, key) {
			if (value.indexOf(key) != -1) {
				return value.replace(key, '<em>' + key + '</em>')
			} else {
				return value
			}
		},
		goRouter(type, id) {
			if (type == 'fund') {
				this.$router.push({
					path: '/funddetail/' + id
				})
			} else if (type == "otc") {
				this.$router.push({
					path: '/finadetail/' + id
				})
			}
		},
		goFinanRouter(type, code, isLoginCheck) {
			// if (type == '2' && this.checkLogin != true) {
			// 	// this.$router.push({ path: '/login', query: { to: '/finadetail/' + code } })
			// 	this.goLogin('/login', '/finadetail/' + code)
			// } else if (type == '2' && this.checkLogin == true) {
			// 	this.$router.push({
			// 		path: '/finadetail/' + code
			// 	})
			// } else {
			// 	this.$router.push({
			// 		path: '/funddetail/' + code
			// 	})
			// }
			console.log(isLoginCheck)
			if (isLoginCheck) {
				if (!this.checkLogin) {
					this.goLogin('/login', '/finadetail/' + code)
				} else {
					this.$router.push({
						path: '/finadetail/' + code
					})
				}
			} else {
				this.$router.push({
					path: '/finadetail/' + code
				})
			}

		},
		goMore(id) {
			if (id == '1fund') {
				this.$router.push({
					path: '/product',
					query: {
						search_type: '3',
						search_field: this.searchText
					}
				})
			} else {
				this.$router.push({
					path: '/product',
					query: {
						search_type: '2',
						search_field: this.searchText
					}
				})
			}
		},
		toMore(type) {
			if (type == '1') {
				if(this.currType == 0) {
					this.$router.push({
						path: '/product'
					})
				} else {
					this.$router.push({
						path: '/product',
						query: {
							search_type: '3',
							search_cate: this.currType
						}
					})
				}

			} else if (type == '2') {
				this.$router.push({
					path: '/product',
					query: {
						search_type: '2',
						search_sort: this.lc_search_list_qx_arr[this.lc_search_index].type
					}
				})
			} else if (type == '3') {
				this.$router.push({
					path: '/news'
				})
			}
		},
		openNew(item) {
			this.showIframe = true
			this.tempItem = item
		},
		switchSearchType(value) {
			this.searchType = value
		},
		toSearch() {
			sessionStorage.setItem('searchType', this.searchType)
			sessionStorage.setItem('searchInput', this.searchInput)
			if (this.searchInput && this.searchInput.length > 0) {
				this.$router.push({
					path: '/search'
				})
			}
		},
		topage(item) {
			if(item.path) {
				let path = item.path
				let name = ""
				if(item.path == '/') {
					name = "主页"
				} else if(item.path == '/product') {
					name = "产品列表"
				} else if(item.path == '/news') {
					name = "理财资讯"
				}
				if (window.qt) {
					try{
						window.QtSubmit.JSICallMethod('ehtsec://nativeLog?event=tabView&openType=理财&tab=' + name)
					} catch(e) {
						console.log(e)
					}

				}
				this.$router.push(path)
			}

		},

		keydown(ev){
		  let that = this
      let event = ev || event
			if(event.key === "Enter" || event.keyCode == 13){
				that.toSearch();
			}
		}
	},
	created() {
		this.getHtyx('1')
		// this.getHtyx('2')
		// this.getHtyx('3')
		this.getCustomFund()
		this.getFollowList()
		this.getRankingList()
		this.getAppggList()
	},
	mounted() {
		var _this = this
		for (var i = 1; i <= 3; i++) {
			let mid = 'main0' + i;
			let mthead = 'thead0' + i
			let scrollmain = this.$refs[mid]
			if (scrollmain) {
				scrollmain.addEventListener('scroll', function () {
					let scrollTop = this.scrollTop
					_this.$refs[mthead].style.transform = 'translateY(' + scrollTop + 'px)'
				})
			}
		}

		let lc_search_list_qx_arr = this.lc_search_list_qx_arr;
		this.queryLcSearchList({
			currentPage: 1,
			lc_search_list_qx: lc_search_list_qx_arr[0].type
		});
	},
	watch: {
		searchText(value, oldvalue) {
			if (value != '') {
				let data = {
					keyword: value.toUpperCase(),
					rows: '10',
					each_rows: '4',
					rows: '40',
					search_type: 'all',
					product_type: '',
					currentPage: '',
					filterfx: '5'
				}
				searchProListByType(data).then(resultVo => {
					if (0 == resultVo.error_no) {
						this.searchArr = this.formatSearchData(resultVo.DataSet0)
						if (resultVo.DataSet0 == '') {
							this.isEmpty = true
						} else {
							this.isEmpty = false
						}
					}
				})
			}
		}
	},
	filters: {
		statusFormat(value) {
			if (value == '0') {
				return '在售'
			} else if (value == '1') {
				return '预售'
			} else if (value == '2') {
				return '结束'
			} else {
				return '--'
			}
		}
	}
}




// WEBPACK FOOTER //
// ./src/pages/home.vue